import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
export const ClientChecklistStatus = z.enum([
    "Not Started",
    "In Progress",
    "Completed",
]);
export const ClientChecklistV1 = z.object({
    masterDisplay: z.boolean(),
    version: z.literal("2000-01-01"),
    onboardingComplete: ClientChecklistStatus,
    investorProfile: ClientChecklistStatus,
    contactInformation: ClientChecklistStatus,
    additionalInformation: ClientChecklistStatus,
    beneficiaries: ClientChecklistStatus,
    affiliation: ClientChecklistStatus,
    onboardingAgreement: ClientChecklistStatus,
    privacyPolicy: ClientChecklistStatus,
    custodianAgreement: ClientChecklistStatus,
});
export const ClientChecklistV2 = z.object({
    masterDisplay: z.boolean(),
    version: z.literal("2024-12-05"),
    onboardingComplete: ClientChecklistStatus,
    investorProfile: ClientChecklistStatus,
    contactInformation: ClientChecklistStatus,
    additionalInformation: ClientChecklistStatus,
    beneficiaries: ClientChecklistStatus,
    affiliation: ClientChecklistStatus,
    investmentAdvisoryAgreement: ClientChecklistStatus,
    fartherDisclosures: ClientChecklistStatus,
    custodianAgreement: ClientChecklistStatus,
});
export const ClientChecklist = z.union([ClientChecklistV1, ClientChecklistV2]);
export const GetClientChecklistResponseV2 = z.object({
    data: ClientChecklist,
});
export const clientChecklistUrlV2 = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/entity/client/${clientId}/onboarding/checklist`
    : `https://middleware.uat.farther.com/entity/client/${clientId}/onboarding/checklist`;
export default async function getClientChecklistV2(clientId, config) {
    const { data } = await axios.get(clientChecklistUrlV2(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            Version: "20241205",
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = GetClientChecklistResponseV2.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = "[getClientChecklistV2] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClientChecklistV2.js.map